/**
 * Prevents annotate-modal click-through: closing via overlay must not open
 * another modal from the grid / suggestion card underneath the same click.
 */
let blockedUntil = 0;

export function blockAnnotateModalOpen(ms = 450) {
  const until = Date.now() + Math.max(0, Number(ms) || 0);
  if (until > blockedUntil) {
    blockedUntil = until;
  }
}

export function canOpenAnnotateModal() {
  return Date.now() >= blockedUntil;
}

export function resetAnnotateModalGuard() {
  blockedUntil = 0;
}

if (typeof window !== 'undefined') {
  window.__box21ResetAnnotateModalGuard = resetAnnotateModalGuard;
}
